import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function jsonValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || control.value === '') {
      return null; // Empty is OK
    }

    try {
      JSON.parse(control.value);
      return null; // Valid JSON
    } catch (e) {
      return { jsonInvalid: true }; // Invalid JSON
    }
  };
}
